import Vue from 'vue'
import Vuex from 'vuex'
import wsm from './modules/wsManage'
Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    wsm
  }
})
export default store;
